export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/battery.1dac4407.svg","height":23,"width":12,"blurWidth":0,"blurHeight":0};